module.exports = __webpack_public_path__ + "static/media/Close_Aero.3ad0d3d0.svg";